import { render } from "./Default-Navigation.vue?vue&type=template&id=1fd48d95"
import script from "./Default-Navigation.vue?vue&type=script&lang=js"
export * from "./Default-Navigation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__